"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var reactive_google_map_1 = require("@dotdev/reactive-google-map");
var component_1 = require("./component");
var StoreLocator = /** @class */ (function () {
    function StoreLocator(options) {
        var _this = this;
        this.options = options;
        this.locations = [];
        this.query = {
            position: null,
            bounds: null,
            search: "",
        };
        this.tasklock = {};
        this.updateQuery = function (query) {
            _this.query = __assign(__assign(__assign({}, _this.query), query), { source: query.source || undefined });
            if (_this.options.onUpdateQuery) {
                _this.options.onUpdateQuery();
            }
            return _this.updateLocations();
        };
        this.fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.options.fetchData) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.options.fetchData(this.query)];
                    case 1:
                        data = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.options.parseData) {
                            data = this.options.parseData(data);
                        }
                        return [2 /*return*/, data];
                }
            });
        }); };
        this.setProvider = function (provider) {
            _this.provider = provider;
        };
        this.setGoogleMapClient = function (googleMapClient) {
            _this.googleMapClient = googleMapClient;
        };
        this.setGoogleMapAutocompleteClient = function (googleMapAutocompleteClient) {
            _this.googleMapAutocompleteClient = googleMapAutocompleteClient;
        };
        this.selectLocation = function (locationId) {
            var selectedLocation = _this.locations.find(function (location) { return location.id === locationId; });
            if (!selectedLocation) {
                throw new Error("Unable to find Location ID \"" + locationId + "\"");
            }
            _this.selected = locationId;
            if (_this.googleMapClient) {
                _this.googleMapClient.mapPanTo(selectedLocation.position);
                if (_this.googleMapClient.mapGetZoom() < 14) {
                    _this.googleMapClient.mapZoomTo(14);
                }
                _this.googleMapClient.infowindowOpen(selectedLocation);
            }
            if (_this.provider) {
                _this.provider.setState({});
            }
        };
        this.selectClear = function () {
            _this.selected = null;
            if (_this.googleMapClient) {
                _this.googleMapClient.infowindowClose();
            }
            if (_this.provider) {
                _this.provider.setState({});
            }
        };
        this.geocoder = new reactive_google_map_1.Geocoder({
            googleMapsApiKey: this.options.googleMapsApiKey,
            googleMapsApiVersion: this.options.googleMapsApiVersion,
        });
    }
    StoreLocator.prototype.updateLocations = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.tasker(function () { return __awaiter(_this, void 0, void 0, function () {
                        var position, _a, selectedLocationStillAvailable;
                        var _this = this;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!this.query.position && this.googleMapClient) {
                                        position = this.googleMapClient.mapGetCenter();
                                        if (position) {
                                            return [2 /*return*/, this.updateQuery({
                                                    position: position,
                                                })];
                                        }
                                    }
                                    _a = this;
                                    return [4 /*yield*/, this.fetchData()];
                                case 1:
                                    _a.locations = _b.sent();
                                    if (this.options.onUpdateLocations) {
                                        this.options.onUpdateLocations();
                                    }
                                    if (this.selected) {
                                        selectedLocationStillAvailable = this.locations.find(function (location) { return location.id === _this.selected; });
                                        if (!selectedLocationStillAvailable) {
                                            this.selectClear();
                                        }
                                    }
                                    if (this.provider) {
                                        this.provider.setState({});
                                    }
                                    return [4 /*yield*/, new Promise(function (r) { return setTimeout(function () { return r(); }, 500); })];
                                case 2:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }, "marker")];
            });
        });
    };
    StoreLocator.prototype.tasker = function (task, lock) {
        if (lock === void 0) { lock = "global"; }
        return __awaiter(this, void 0, void 0, function () {
            var next;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.tasklock[lock] && this.tasklock[lock].busy === true) {
                            this.tasklock[lock].next = task;
                            return [2 /*return*/];
                        }
                        this.tasklock[lock] = { busy: true, next: null };
                        return [4 /*yield*/, task()];
                    case 1:
                        _a.sent();
                        if (!this.tasklock[lock].next) return [3 /*break*/, 3];
                        next = this.tasklock[lock].next;
                        this.tasklock[lock].next = null;
                        return [4 /*yield*/, next()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.tasklock[lock].busy = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    StoreLocator.Provider = component_1.StoreLocatorProvider;
    StoreLocator.Search = component_1.StoreLocatorSearch;
    StoreLocator.Map = component_1.StoreLocatorMap;
    StoreLocator.List = component_1.StoreLocatorList;
    StoreLocator.Geolocate = component_1.StoreLocatorGeolocate;
    StoreLocator.buildElasticsearchQuery = function (size, from, query, distance) {
        if (size === void 0) { size = 10; }
        if (from === void 0) { from = 0; }
        var body = {
            query: {
                bool: {
                    should: [],
                },
            },
            size: size,
            from: from,
        };
        if (query) {
            if (query.bounds) {
                body.query.bool.should.push({
                    geo_bounding_box: {
                        location: {
                            top_left: {
                                lat: query.bounds.tl.lat,
                                lon: query.bounds.tl.lng,
                            },
                            bottom_right: {
                                lat: query.bounds.br.lat,
                                lon: query.bounds.br.lng,
                            },
                        },
                    },
                });
                body.sort = [{
                        _geo_distance: {
                            location: {
                                lat: (query.bounds.tl.lat + query.bounds.br.lat) / 2,
                                lon: (query.bounds.tl.lng + query.bounds.br.lng) / 2,
                            },
                            order: "asc",
                            unit: "km",
                            distance_type: "arc",
                        },
                    }];
            }
            if (query.position) {
                body.query.bool.should.push({
                    geo_distance: {
                        distance: "100km",
                        location: {
                            lat: query.position.lat,
                            lon: query.position.lng,
                        },
                    },
                });
                body.sort = [{
                        _geo_distance: {
                            location: {
                                lat: query.position.lat,
                                lon: query.position.lng,
                            },
                            order: "asc",
                            unit: "km",
                            distance_type: "arc",
                        },
                    }];
            }
        }
        return body;
    };
    return StoreLocator;
}());
exports.StoreLocator = StoreLocator;
//# sourceMappingURL=store-locator.js.map